module.exports = __webpack_public_path__ + "static/media/magic_ring.c027d0eb.png";